<template>
    <div class="field">
        <div class="control has-icons-left">
            <input v-model="model"
                   v-bind:class="{ 'is-danger': error && error.length > 0 }"
                   class="input"
                   type="text"
                   placeholder="Type Model">
            <span class="icon is-small is-left">
                <i class="fas fa-cogs"></i>
            </span>
            <p v-if="error && error.length > 0" class="help is-danger">{{ error[0] }}</p>
        </div>
    </div>
</template>

<script>
    export default {
        computed: {
            model: {
                get: function () {
                    return this.$store.getters.getNewCarModel
                },
                set: function (value) {
                    this.$store.dispatch('setNewCarModel', value)
                }
            },
            error: {
                get: function () {
                    return this.$store.getters.getNewCarErrorModel
                }
            }
        }
    }
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/components/Cars/Create/Inputs/ModelInput.vue